<script setup lang="ts">
withDefaults(defineProps<{ size?: 'sm' | 'md' }>(), { size: 'md' })
const star = 'M48,64.7 L62.6,61 L68.7,79.8 L48,64.7 Z M81.6,40.4 L55.9,40.4 L48,16.2 L40.1,40.4 L14.4,40.4 L35.2,55.4 L27.3,79.6 L48.1,64.6 L60.9,55.4 L81.6,40.4 Z'
</script>

<template>
  <span
    class="tp-logo"
    :data-size="size"
  >
    <svg
      class="tp-logo__star"
      viewBox="0 0 96 96"
      aria-hidden="true"
    >
      <path
        :d="star"
        fill="#00b67a"
      />
    </svg>
    <span class="tp-logo__wordmark">Trustpilot</span>
  </span>
</template>

<style scoped>
.tp-logo {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}
.tp-logo__star {
  width: 1.25rem;
  height: 1.25rem;
  flex: none;
}
.tp-logo[data-size='sm'] .tp-logo__star {
  width: 1rem;
  height: 1rem;
}
.tp-logo__wordmark {
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--color-med-deep-navy, #0a2d38);
}
.dark-bg .tp-logo__wordmark {
  color: #fff;
}
.dark-bg .tp-logo__star path {
  fill: currentColor;
}
.tp-logo[data-size='sm'] .tp-logo__wordmark {
  font-size: 0.875rem;
}
</style>
